<template>
  <div class="hold-transition layout-top-nav">
    <loading v-if="cargando" />
    <div
      class="wrapper bg-light"
      :class="
        vistaConversacion ? 'd-flex flex-column vh-100 overflow-hidden' : ''
      "
    >
      <section
        class="content pt-2 pb-2"
        :class="
          vistaConversacion
            ? 'd-flex flex-column flex-grow-1 overflow-hidden mb-0'
            : ''
        "
      >
        <div
          :class="
            vistaConversacion
              ? 'container-fluid d-flex flex-column h-100'
              : 'container'
          "
        >
          <div class="card shadow-sm mb-2 flex-shrink-0">
            <div class="bg-support p-1"></div>
            <div class="card-body bg-white py-2">
              <div class="row align-items-center">
                <div class="col-auto mb-2 mb-md-0">
                  <img
                    src="/img/logos/logo-sos.png"
                    alt="S.O.S Contingencias"
                    class="img-fluid"
                    width="110"
                  />
                </div>
                <div class="col-md mb-2 mb-md-0">
                  <span class="badge bg-support-green text-dark">
                    S.O.S Contingencias S.A.S
                  </span>
                  <h5 class="mb-0 mt-1">Gestión de tickets</h5>
                  <p class="mb-0 text-muted small">
                    <template v-if="datosUrl.ticket">
                      Lea la respuesta de soporte y continúe la conversación.
                    </template>
                    <template v-else>
                      Cuéntenos qué necesita. El equipo de soporte le
                      responderá en este mismo canal.
                    </template>
                  </p>
                </div>
                <div class="col-md-auto small">
                  <a
                    class="d-block text-nowrap"
                    href="https://www.soscontingencias.com.co/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fas fa-globe mr-1"></i>
                    www.soscontingencias.com.co
                  </a>
                  <a
                    class="d-block text-nowrap"
                    href="https://wa.me/573233140852"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fab fa-whatsapp mr-1"></i>
                    +57 323 314 0852
                  </a>
                  <span class="text-muted text-nowrap">
                    <a
                      href="https://facebook.com/soscontingencia"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fab fa-facebook-f mr-1"></i>Facebook
                    </a>
                    <span class="mx-1">·</span>
                    <a
                      href="https://instagram.com/soscontingencias"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i class="fab fa-instagram mr-1"></i>Instagram
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="alert alert-default-danger shadow-sm" v-if="erroresValidacion.length > 0" role="alert">
            <h6 class="mb-2">
              <i class="icon fas fa-exclamation-triangle"></i>
              No pudimos abrir esta solicitud
            </h6>
            <p
              v-for="(error, index) in erroresValidacion"
              :key="index"
              class="mb-0"
            >
              <i class="fas fa-times-circle mr-1"></i>
              {{ error }}
            </p>
          </div>

          <template v-else>
            <div
              class="card shadow-sm mb-2"
              v-if="
                !vistaConversacion &&
                (datosUrl.user ||
                  datosUrl.email ||
                  datosUrl.cliente ||
                  datosUrl.plataformaName)
              "
            >
              <div class="card-body bg-white py-2">
                <div class="row">
                  <div
                    class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0"
                    v-if="datosUrl.user"
                  >
                    <span class="text-muted d-block small">Solicitante</span>
                    <span class="dato-solicitud text-capitalize">
                      <i class="fas fa-user mr-1 text-muted"></i>
                      {{ datosUrl.user }}
                    </span>
                  </div>
                  <div
                    class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0"
                    v-if="datosUrl.email"
                  >
                    <span class="text-muted d-block small">
                      Le responderemos a
                    </span>
                    <span class="dato-solicitud">
                      <i class="fas fa-envelope mr-1 text-muted"></i>
                      {{ datosUrl.email }}
                    </span>
                  </div>
                  <div
                    class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0"
                    v-if="datosUrl.cliente"
                  >
                    <span class="text-muted d-block small">Cliente</span>
                    <span class="dato-solicitud">
                      <i class="fas fa-building mr-1 text-muted"></i>
                      {{ datosUrl.cliente }}
                    </span>
                  </div>
                  <div
                    class="col-12 col-sm-6 col-xl-3"
                    v-if="datosUrl.plataformaName"
                  >
                    <span class="text-muted d-block small">Plataforma</span>
                    <span class="dato-solicitud">
                      <i class="fas fa-desktop mr-1 text-muted"></i>
                      {{ datosUrl.plataformaName }}
                      <small class="text-muted">({{ datosUrl.plataforma }})</small>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row flex-grow-1 overflow-hidden" v-if="vistaConversacion">
              <div class="col-4 d-flex h-100">
                <div class="card shadow-sm w-100 mb-0 overflow-auto">
                  <div class="bg-support p-1"></div>
                  <div class="card-header bg-white py-2">
                    <div class="d-flex justify-content-between align-items-start">
                      <h5 class="mb-0">
                        <i class="fas fa-ticket-alt mr-1"></i>
                        {{ ticket_data.ticket_code }}
                      </h5>
                      <span class="badge bg-support-green text-dark">
                        {{ ticket_data.nEstado }}
                      </span>
                    </div>
                    <div class="mt-2">{{ ticket_data.asunto }}</div>
                  </div>
                  <div class="card-body">
                    <span class="text-muted d-block small">Solicitud</span>
                    <p class="mb-3 ticket-descripcion">
                      {{ ticket_data.descripcion }}
                    </p>
                    <adjuntos-ticket-links :adjuntos="ticket_data.adjuntos" />
                    <div class="mb-2" v-if="datosUrl.user">
                      <span class="text-muted d-block small">Solicitante</span>
                      <span class="text-capitalize">
                        <i class="fas fa-user mr-1 text-muted"></i>
                        {{ datosUrl.user }}
                      </span>
                    </div>
                    <div class="mb-2" v-if="datosUrl.email">
                      <span class="text-muted d-block small">Correo</span>
                      <span>
                        <i class="fas fa-envelope mr-1 text-muted"></i>
                        {{ datosUrl.email }}
                      </span>
                    </div>
                    <div class="mb-2" v-if="datosUrl.cliente">
                      <span class="text-muted d-block small">Cliente</span>
                      <span>
                        <i class="fas fa-building mr-1 text-muted"></i>
                        {{ datosUrl.cliente }}
                      </span>
                    </div>
                    <div class="mb-2" v-if="datosUrl.plataformaName">
                      <span class="text-muted d-block small">Plataforma</span>
                      <span>
                        <i class="fas fa-desktop mr-1 text-muted"></i>
                        {{ datosUrl.plataformaName }}
                        <small class="text-muted">({{ datosUrl.plataforma }})</small>
                      </span>
                    </div>
                    <div class="mb-2">
                      <span class="text-muted d-block small">Registrado</span>
                      <span>
                        <i class="far fa-clock mr-1 text-muted"></i>
                        {{ formatearFecha(ticket_data.created_at) }}
                      </span>
                    </div>
                    <div>
                      <span class="text-muted d-block small">Actualizado</span>
                      <span>
                        <i class="far fa-clock mr-1 text-muted"></i>
                        {{ formatearFecha(ticket_data.updated_at) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-8 d-flex h-100">
                <div class="card shadow-sm direct-chat direct-chat-primary w-100 mb-0 overflow-hidden d-flex flex-column">
              <loading v-if="guardandoRespuesta" />
              <div class="bg-support-green p-1 flex-shrink-0"></div>
              <form
                v-if="!ticketCerrado && seguimientos.length > 0"
                class="px-3 pt-2 pb-2 border-bottom bg-white flex-shrink-0"
                @submit.prevent="enviarRespuesta"
              >
                <label class="mb-1">Su respuesta</label>
                <div class="input-group">
                  <textarea
                    v-model="respuesta.mensaje"
                    class="form-control"
                    rows="2"
                    placeholder="Escriba su respuesta"
                    @keydown.enter.exact.prevent="enviarRespuesta"
                  ></textarea>
                  <div class="input-group-append">
                    <button
                      type="submit"
                      class="btn bg-support-blue"
                      title="Enviar respuesta"
                      :disabled="
                        guardandoRespuesta ||
                        !respuesta.mensaje ||
                        !respuesta.mensaje.trim()
                      "
                    >
                      <i class="fas fa-paper-plane"></i>
                    </button>
                  </div>
                </div>
                <div class="d-flex flex-wrap align-items-center mt-2">
                  <div class="custom-control custom-checkbox mr-3">
                    <input
                      id="cerrar-ticket"
                      v-model="respuesta.cerrar"
                      type="checkbox"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="cerrar-ticket">
                      Cerrar ticket
                    </label>
                  </div>
                  <small class="text-muted">{{ textoRespuesta }}</small>
                </div>
                <div
                  class="adjuntos-zona adjuntos-zona-compacta mt-2"
                  :class="{
                    'adjuntos-zona-activa': arrastrandoAdjuntos,
                    'adjuntos-zona-llena': adjuntos.length >= maxAdjuntos,
                  }"
                  @click="abrirSelectorAdjuntos"
                  @dragenter.prevent="arrastrandoAdjuntos = true"
                  @dragover.prevent="arrastrandoAdjuntos = true"
                  @dragleave.prevent="salirZonaAdjuntos"
                  @drop.prevent="soltarAdjuntos"
                >
                  <input
                    ref="adjuntosInput"
                    type="file"
                    class="d-none"
                    multiple
                    accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx,.csv"
                    @click.stop
                    @change="seleccionarAdjuntos"
                  />
                  <span class="small">
                    <i class="fas fa-paperclip mr-1 text-muted"></i>
                    Arrastre o seleccione archivos
                  </span>
                  <span class="badge badge-light ml-1">
                    {{ adjuntos.length }} de {{ maxAdjuntos }}
                  </span>
                </div>
                <ul
                  v-if="adjuntos.length"
                  class="list-unstyled adjuntos-lista mb-0 mt-1"
                >
                  <li
                    v-for="(archivo, index) in adjuntos"
                    :key="'resp-' + archivo.name + '-' + archivo.size + '-' + index"
                    class="d-flex align-items-center"
                  >
                    <i :class="iconoAdjunto(archivo)" class="mr-1 text-muted"></i>
                    <span class="text-truncate flex-fill" :title="archivo.name">
                      {{ archivo.name }}
                    </span>
                    <small class="text-muted mx-1 text-nowrap">
                      {{ formatearPeso(archivo.size) }}
                    </small>
                    <button
                      type="button"
                      class="btn btn-link btn-sm text-danger p-0"
                      title="Quitar"
                      @click="quitarAdjunto(index)"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </li>
                </ul>
                <small
                  v-for="(error, index) in erroresAdjuntos"
                  :key="'resp-adjunto-' + index"
                  class="text-danger d-block"
                >
                  {{ error }}
                </small>
              </form>
              <div v-if="!seguimientos.length" class="px-3 py-2 border-bottom bg-white flex-shrink-0">
                <div class="alert alert-secondary mb-0 py-2">
                  A la espera de la respuesta del equipo de soporte.
                </div>
              </div>
              <div v-if="ticketCerrado" class="px-3 py-2 border-bottom bg-white flex-shrink-0">
                <div class="alert alert-secondary mb-0 py-2">
                  Este ticket está cerrado. Ya no admite respuestas.
                </div>
              </div>
              <div class="px-3 py-1 border-bottom bg-light small text-muted flex-shrink-0">
                Historial de seguimientos.
              </div>
              <div
                ref="mensajes"
                class="direct-chat-messages flex-grow-1 overflow-auto h-auto bg-white"
              >
                <div v-if="cargandoSeguimientos" class="text-center text-muted py-4">
                  Cargando seguimientos...
                </div>
                <div
                  v-else-if="!mensajes.length"
                  class="text-center text-muted py-4"
                >
                  Este ticket no tiene seguimientos.
                </div>
                <template v-else>
                  <div
                    v-for="(item, index) in mensajes"
                    :key="item._key"
                  >
                    <div
                      v-if="mostrarDia(index)"
                      class="text-center my-2"
                    >
                      <span class="badge badge-light">
                        {{ etiquetaDia(item.created_at) }}
                      </span>
                    </div>
                    <div
                      class="direct-chat-msg"
                      :class="{ right: esSolicitante(item) }"
                    >
                      <div class="direct-chat-infos clearfix">
                        <span
                          class="direct-chat-name"
                          :class="
                            esSolicitante(item) ? 'float-right' : 'float-left'
                          "
                        >
                          {{ item.autor_nombre }}
                        </span>
                        <span
                          class="direct-chat-timestamp"
                          :class="
                            esSolicitante(item) ? 'float-left' : 'float-right'
                          "
                        >
                          {{ formatearHora(item.created_at) }}
                        </span>
                      </div>
                      <span
                        class="direct-chat-img d-flex align-items-center justify-content-center text-white"
                        :class="
                          esSolicitante(item) ? 'bg-secondary' : 'bg-primary'
                        "
                      >
                        <i
                          :class="
                            esSolicitante(item)
                              ? 'fas fa-user'
                              : 'fas fa-headset'
                          "
                        ></i>
                      </span>
                      <div class="direct-chat-text">
                        {{ item.mensaje }}
                        <adjuntos-ticket-links :adjuntos="item.adjuntos" />
                        <div v-if="cambioEstado(item)" class="mt-1">
                          <span class="badge badge-info">
                            {{ item.nEstadoNuevo }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mb-0" v-if="!datosUrl.ticket">
              <div class="bg-support p-1"></div>
              <div class="card-header bg-white py-2">
                <h6 class="mb-0">
                  <i class="fas fa-edit mr-1"></i>
                  Nueva solicitud
                </h6>
              </div>
              <form @submit.prevent="enviar">
                <div class="card-body bg-white py-2">
                  <div class="row">
                    <div class="col-lg-7">
                      <div class="form-group mb-2">
                        <label class="mb-0 small">Asunto *</label>
                        <input
                          v-model.trim="form.asunto"
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="Resuma la solicitud"
                          :class="claseCampo('asunto')"
                          @blur="$v.form.asunto.$touch()"
                        />
                        <small
                          v-if="$v.form.asunto.$dirty && !$v.form.asunto.required"
                          class="text-danger"
                        >
                          Indique el asunto.
                        </small>
                      </div>
                      <div class="form-group mb-2 mb-lg-0">
                        <label class="mb-0 small">Descripción *</label>
                        <textarea
                          v-model.trim="form.descripcion"
                          rows="3"
                          class="form-control form-control-sm"
                          placeholder="Módulo y qué necesita"
                          :class="claseCampo('descripcion')"
                          @blur="$v.form.descripcion.$touch()"
                        ></textarea>
                        <small
                          v-if="
                            $v.form.descripcion.$dirty &&
                            !$v.form.descripcion.required
                          "
                          class="text-danger"
                        >
                          Describa la solicitud.
                        </small>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <label class="mb-0 small">Adjuntos</label>
                        <span class="badge badge-light">
                          {{ adjuntos.length }} de {{ maxAdjuntos }}
                        </span>
                      </div>
                      <div
                        class="adjuntos-zona"
                        :class="{
                          'adjuntos-zona-activa': arrastrandoAdjuntos,
                          'adjuntos-zona-llena': adjuntos.length >= maxAdjuntos,
                        }"
                        @click="abrirSelectorAdjuntos"
                        @dragenter.prevent="arrastrandoAdjuntos = true"
                        @dragover.prevent="arrastrandoAdjuntos = true"
                        @dragleave.prevent="salirZonaAdjuntos"
                        @drop.prevent="soltarAdjuntos"
                      >
                        <input
                          ref="adjuntosInput"
                          type="file"
                          class="d-none"
                          multiple
                          accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx,.csv"
                          @click.stop
                          @change="seleccionarAdjuntos"
                        />
                        <i class="fas fa-cloud-upload-alt text-muted"></i>
                        <span class="d-block small">
                          Arrastre los archivos o haga clic para seleccionarlos
                        </span>
                        <span class="d-block text-muted adjuntos-ayuda">
                          JPG, PNG, PDF, Excel, Word o CSV. Máximo 5 MB.
                        </span>
                      </div>
                      <ul
                        v-if="adjuntos.length"
                        class="list-unstyled adjuntos-lista mb-0 mt-1"
                      >
                        <li
                          v-for="(archivo, index) in adjuntos"
                          :key="archivo.name + '-' + archivo.size + '-' + index"
                          class="d-flex align-items-center"
                        >
                          <i
                            :class="iconoAdjunto(archivo)"
                            class="mr-1 text-muted"
                          ></i>
                          <span class="text-truncate flex-fill" :title="archivo.name">
                            {{ archivo.name }}
                          </span>
                          <small class="text-muted mx-1 text-nowrap">
                            {{ formatearPeso(archivo.size) }}
                          </small>
                          <button
                            type="button"
                            class="btn btn-link btn-sm text-danger p-0"
                            title="Quitar"
                            @click="quitarAdjunto(index)"
                          >
                            <i class="fas fa-times"></i>
                          </button>
                        </li>
                      </ul>
                      <small
                        v-for="(error, index) in erroresAdjuntos"
                        :key="'adjunto-' + index"
                        class="text-danger d-block"
                      >
                        {{ error }}
                      </small>
                    </div>
                  </div>
                </div>
                <div class="card-footer bg-white py-2 text-right">
                  <button
                    type="button"
                    class="btn btn-sm btn-default mr-2"
                    @click="limpiar()"
                  >
                    <i class="fas fa-eraser mr-1"></i>
                    Limpiar
                  </button>
                  <button
                    type="submit"
                    v-if="!$v.form.$invalid"
                    class="btn btn-sm bg-support-blue"
                    :disabled="cargando"
                  >
                    <i class="fas fa-paper-plane mr-1"></i>
                    Enviar ticket
                  </button>
                </div>
              </form>
            </div>
          </template>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, maxLength } from "vuelidate/lib/validators";
import Loading from "../../../../../components/LoadingSpinner";
import adjuntosTicket from "./adjuntosTicket";
import AdjuntosTicketLinks from "./AdjuntosTicketLinks";

const PLATAFORMAS = [
  {
    id: "sos",
    etiqueta: "SOS Contingencias",
    alias: [
      "sos",
      "sos contingencias",
      "s.o.s",
      "s.o.s contingencias",
      "s.o.s. contingencias",
    ],
  },
  {
    id: "support",
    etiqueta: "Support 7-24",
    alias: [
      "support",
      "support 7-24",
      "support 724",
      "support724",
      "support7-24",
    ],
  },
  {
    id: "trafigura",
    etiqueta: "Trafigura",
    alias: ["trafigura"],
  },
  {
    id: "biomax",
    etiqueta: "Biomax",
    alias: ["biomax"],
  },
];

export default {
  name: "EnviarTicket",

  components: {
    Loading,
    AdjuntosTicketLinks,
  },

  mixins: [adjuntosTicket],

  data() {
    return {
      cargando: false,
      erroresValidacion: [],
      datosUrl: {
        user: null,
        email: null,
        cliente: null,
        plataforma: null,
        ticket: null,
      },
      listasForms: {
        plataformas: [],
      },
      ticket_data: {},
      form: {},
      seguimientos: [],
      cargandoSeguimientos: false,
      guardandoRespuesta: false,
      respuesta: {
        mensaje: "",
        cerrar: false,
      },
    };
  },

    computed: {
    vistaConversacion() {
      return Boolean(
        this.datosUrl.ticket && this.ticket_data && this.ticket_data.id
      );
    },

    ticketCerrado() {
      return Number(this.ticket_data && this.ticket_data.estado) === 6;
    },

    mensajes() {
      if (!this.ticket_data || !this.ticket_data.id) {
        return [];
      }
      const lista = this.seguimientos.map((item) => ({
        ...item,
        _key: "seg-" + item.id,
      }));
      if (this.ticket_data.descripcion) {
        lista.push({
          _key: "apertura-" + this.ticket_data.id,
          origen: 2,
          autor_nombre: this.ticket_data.solicitante,
          mensaje: this.ticket_data.descripcion,
          created_at: this.ticket_data.created_at,
          visibilidad: 1,
          adjuntos: this.ticket_data.adjuntos || [],
        });
      }
      return lista;
    },

    textoRespuesta() {
      if (this.respuesta.cerrar) {
        return "El ticket pasará a Cerrado.";
      }
      return "El ticket quedará en Esperando Respuesta.";
    },
  },

  validations: {
    form: {
      asunto: { required, maxLength: maxLength(100) },
      descripcion: { required, maxLength: maxLength(500) },
    },
  },

  methods: {
    async getIndex() {
      try {
        this.cargando = true;
        const tokenValido = this.validarToken();
        if (tokenValido?.errores?.length > 0) {
          this.erroresValidacion = tokenValido.errores;
          return;
        }

        await this.getPlataformas();
        const valido = await this.validarSolicitud();
        await this.limpiar();

        if (valido?.errores?.length > 0) {
          this.erroresValidacion = valido.errores;
          return;
        }
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error al obtener los datos 1",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3500,
          timerProgressBar: true,
        });
      } finally {
        this.cargando = false;
      }
    },

    decodificarToken(token) {
      const normalizado = String(token).replace(/-/g, "+").replace(/_/g, "/");
      const relleno = normalizado.padEnd(
        normalizado.length + ((4 - (normalizado.length % 4)) % 4),
        "="
      );
      const bytes = Uint8Array.from(atob(relleno), (c) => c.charCodeAt(0));
      return JSON.parse(new TextDecoder().decode(bytes));
    },

    validarToken() {
      const token = this.$route.query.token;
      if (!token) {
        return { errores: ["El enlace no contiene un token."] };
      }

      let payload;
      try {
        payload = this.decodificarToken(token);
      } catch (error) {
        return { errores: ["El enlace no es válido."] };
      }

      const ahora = Math.floor(Date.now() / 1000);
      if (!payload.exp || ahora >= Number(payload.exp)) {
        return { errores: ["El enlace venció. Solicite uno nuevo."] };
      }

      this.datosUrl = {
        user: payload.user || null,
        email: payload.email || null,
        cliente: payload.cliente || null,
        plataforma: payload.plataforma || null,
        ticket: payload.ticket || this.datosUrl.ticket || this.$route.query.ticket || null,
      };

      return true;
    },

    async validarSolicitud() {
      let errores = [];
      // Se valida el contenido de la solicitud
      if (
        !this.datosUrl.user ||
        !this.datosUrl.email ||
        !this.datosUrl.plataforma
      ) {
        errores.push("El contenido de la solicitud no es correcto.");
      }

      // Se valida que la plataforma sea valida
      const plataforma = this.listasForms.plataformas.find(
        (plataforma) => plataforma.cod_alterno === this.datosUrl.plataforma,
      );

      if (!plataforma) {
        errores.push("Plataforma no encontrada en la solicitud.");
      }

      this.datosUrl.plataformaName = plataforma?.descripcion || null;
      this.datosUrl.plataformaId = plataforma?.numeracion || null;

      if (this.datosUrl.ticket) {
        await this.getTicket();
        if (!this.ticket_data) {
          errores.push("Ticket no encontrado.");
        }
      }

      return errores.length > 0 ? { errores } : true;
    },

    limpiar() {
      // Guardar en variable los datos que vuenen de la url
      const { user, email, cliente, plataforma, ticket } = this.datosUrl;
      console.log(user, email, cliente, plataforma, ticket);

      this.form = {
        user,
        email,
        cliente: cliente || null,
        plataforma: this.datosUrl.plataformaId,
        plataformaCode: this.datosUrl.plataforma,
        ticket_code: ticket || null,
        asunto: "",
        descripcion: "",
      };
      this.limpiarAdjuntos();
    },

    formatearFecha(valor) {
      if (!valor) {
        return "";
      }
      const fecha = new Date(valor);
      if (Number.isNaN(fecha.getTime())) {
        return valor;
      }
      return fecha.toLocaleString("es-CO", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    claseCampo(campo) {
      const control = this.$v.form[campo];
      if (!control.$dirty) {
        return "";
      }
      return control.$invalid ? "is-invalid" : "is-valid";
    },

    async getPlataformas() {
      const response = await axios.get("api/public/lista/PSOS", {
        params: {
          cod_alterno: this.datosUrl.plataforma,
        },
      });
      this.listasForms.plataformas = response.data;
    },

    getTicket() {
      this.cargando = true;
      return axios
        .get(`/api/public/soporte/tickets/${this.datosUrl.ticket}`)
        .then((response) => {
          this.ticket_data = response?.data?.data?.ticket || null;
          if (this.ticket_data && this.ticket_data.id) {
            return this.cargarSeguimientos();
          }
          this.seguimientos = [];
        })
        .finally(() => {
          this.cargando = false;
        });
    },

    cargarSeguimientos() {
      if (!this.datosUrl.ticket) {
        return Promise.resolve();
      }
      this.cargandoSeguimientos = true;
      return axios
        .get(
          "/api/public/soporte/tickets/" +
            this.datosUrl.ticket +
            "/seguimientos"
        )
        .then((response) => {
          this.seguimientos = response.data.seguimientos || [];
          if (response.data.ticket) {
            this.ticket_data = response.data.ticket;
          }
        })
        .catch((error) => {
          this.avisarError(error);
        })
        .finally(() => {
          this.cargandoSeguimientos = false;
          this.$nextTick(this.irAlInicio);
        });
    },

    enviarRespuesta() {
      const mensaje = (this.respuesta.mensaje || "").trim();
      if (!this.ticket_data || !mensaje || this.guardandoRespuesta || this.ticketCerrado) {
        return;
      }
      this.$swal({
        title: "¿Está seguro de enviar esta respuesta?",
        text: this.textoRespuesta,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, enviar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.guardarRespuesta();
        }
      });
    },

    guardarRespuesta() {
      const datos = this.formDataAdjuntos({
        mensaje: (this.respuesta.mensaje || "").trim(),
        cerrar: this.respuesta.cerrar,
        email: this.datosUrl.email,
      });
      this.guardandoRespuesta = true;
      axios
        .post(
          "/api/public/soporte/tickets/" +
            this.datosUrl.ticket +
            "/seguimientos",
          datos
        )
        .then((response) => {
          this.respuesta = {
            mensaje: "",
            cerrar: false,
          };
          this.limpiarAdjuntos();
          if (response.data.ticket) {
            this.ticket_data = response.data.ticket;
          }
          this.$swal({
            icon: "success",
            title: response.data.message || "Respuesta registrada",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          return this.cargarSeguimientos();
        })
        .catch((error) => {
          this.avisarError(error);
        })
        .finally(() => {
          this.guardandoRespuesta = false;
        });
    },

    esSolicitante(item) {
      return Number(item.origen) === 2;
    },

    cambioEstado(item) {
      return (
        item.estado_nuevo &&
        Number(item.estado_nuevo) !== Number(item.estado_anterior) &&
        item.nEstadoNuevo
      );
    },

    mostrarDia(index) {
      if (index === 0) {
        return true;
      }
      return (
        this.dia(this.mensajes[index].created_at) !==
        this.dia(this.mensajes[index - 1].created_at)
      );
    },

    dia(valor) {
      const fecha = new Date(valor);
      if (Number.isNaN(fecha.getTime())) {
        return "";
      }
      return fecha.toLocaleDateString("es-CO");
    },

    etiquetaDia(valor) {
      const fecha = new Date(valor);
      if (Number.isNaN(fecha.getTime())) {
        return "";
      }
      const hoy = new Date();
      const ayer = new Date();
      ayer.setDate(hoy.getDate() - 1);
      if (fecha.toLocaleDateString("es-CO") === hoy.toLocaleDateString("es-CO")) {
        return "Hoy";
      }
      if (fecha.toLocaleDateString("es-CO") === ayer.toLocaleDateString("es-CO")) {
        return "Ayer";
      }
      return fecha.toLocaleDateString("es-CO", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },

    formatearHora(valor) {
      if (!valor) {
        return "";
      }
      const fecha = new Date(valor);
      if (Number.isNaN(fecha.getTime())) {
        return valor;
      }
      return fecha.toLocaleTimeString("es-CO", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },

    irAlInicio() {
      const caja = this.$refs.mensajes;
      if (caja) {
        caja.scrollTop = 0;
      }
    },

    avisarError(error) {
      const cuerpo = error && error.response && error.response.data;
      const lista = cuerpo && cuerpo.errors ? Object.values(cuerpo.errors) : [];
      const primero = Array.isArray(lista[0]) ? lista[0][0] : lista[0];
      const mensaje =
        primero ||
        (cuerpo && (cuerpo.message || cuerpo.error)) ||
        error;
      this.$swal({
        icon: "error",
        title: "Ocurrió un error: " + mensaje,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    },

    enviar() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }

      const datos = this.formDataAdjuntos(this.form);

      this.cargando = true;
      axios
        .post("/api/public/soporte/tickets", datos)
        .then((response) => {
          const ticket = response?.data?.data?.ticket || null;
          const ticketCode = ticket?.ticket_code || null;
          this.datosUrl.ticket = ticketCode;
          this.form.ticket_code = ticketCode;
          if (ticket) {
            this.ticket_data = ticket;
          }
          this.seguimientos = [];
          this.respuesta = {
            mensaje: "",
            cerrar: false,
          };
          this.limpiarAdjuntos();
          this.$swal({
            icon: "success",
            title: response?.data?.message || "Ticket enviado",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          if (ticketCode) {
            return this.getTicket();
          }
        })
        .catch((error) => {
          const cuerpo = error?.response?.data;
          const errores = cuerpo?.errors ? Object.values(cuerpo.errors) : [];
          const primero = Array.isArray(errores[0]) ? errores[0][0] : errores[0];
          this.$swal({
            icon: "error",
            title: primero || cuerpo?.message || "No fue posible enviar el ticket",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3500,
            timerProgressBar: true,
          });
        })
        .finally(() => {
          this.cargando = false;
        });
    },
  },

  mounted() {
    this.getIndex();
  },
};
</script>

<style scoped>
.direct-chat-text,
.ticket-descripcion {
  white-space: pre-wrap;
}

.dato-solicitud {
  display: block;
  overflow-wrap: anywhere;
}

.adjuntos-zona {
  border: 1px dashed #ced4da;
  border-radius: 0.25rem;
  background: #f8f9fa;
  text-align: center;
  padding: 0.65rem 0.5rem;
  cursor: pointer;
}

.adjuntos-zona-activa {
  border-color: #1a73e8;
  background: #eef5ff;
}

.adjuntos-zona-llena {
  cursor: default;
  opacity: 0.8;
}

.adjuntos-zona-compacta {
  padding: 0.35rem 0.5rem;
  text-align: left;
}

.adjuntos-ayuda {
  font-size: 0.75rem;
}

.adjuntos-lista li {
  padding: 0.15rem 0;
  border-top: 1px solid #e9ecef;
  font-size: 0.85rem;
}
</style>
